export function SET_PREAPPROVALS (state, data) {
    state.preapprovals = data.preapprovals
}